import styles from './BlockMeter.module.css';

const DEFAULT_BLOCKS = 16;

const getBlockColor = (position) => {
    if (position < 0.60) return '#22c55e';
    if (position < 0.85) return '#fb923c';
    return '#ef4444';
};

export default function BlockMeter({
    value = 0,
    label,
    orientation = 'horizontal',
    numBlocks = DEFAULT_BLOCKS,
    showValue = false,
    fillHeight = false,
}) {
    const isVertical = orientation === 'vertical';
    const containerClass = isVertical
        ? `${styles.containerVertical} ${fillHeight ? styles.fillHeight : ''}`
        : styles.containerHorizontal;
    const barClass = isVertical ? styles.barVertical : styles.barHorizontal;
    const blockClass = isVertical ? styles.blockVertical : styles.blockHorizontal;

    // For vertical, we render blocks from bottom to top (reverse order)
    const blocks = [...Array(numBlocks)].map((_, i) => {
        const index = isVertical ? (numBlocks - 1 - i) : i;
        const blockThreshold = (index + 1) / numBlocks;
        const blockPosition = index / (numBlocks - 1);
        const isActive = value >= blockThreshold;
        const color = getBlockColor(blockPosition);

        return (
            <div
                key={i}
                className={`${blockClass} ${isActive ? styles.active : ''}`}
                style={{ '--block-color': color }}
            />
        );
    });

    return (
        <div className={containerClass}>
            {label && <span className={styles.label}>{label}</span>}
            <div className={barClass}>
                {blocks}
            </div>
            {showValue && (
                <span className={styles.value}>{(value * 100).toFixed(0)}%</span>
            )}
        </div>
    );
}
